import { render, staticRenderFns } from "./icon-exchange.vue?vue&type=template&id=e9f95440&scoped=true&"
import script from "./icon-exchange.vue?vue&type=script&lang=js&"
export * from "./icon-exchange.vue?vue&type=script&lang=js&"
import style0 from "./icon-exchange.vue?vue&type=style&index=0&id=e9f95440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f95440",
  null
  
)

export default component.exports